import axios from 'axios'
import fetchAccessToken from '../utils/fetchAccessToken';

const getFleetExecutions = async(ids?: string[]) => {
  const token = await fetchAccessToken();

  return axios.get(`${process.env.REACT_APP_URL}/v2/user/fleet_executions`,{
    headers: {
      'Content-Type' : 'application/json',
      'Authorization': `Bearer ${token}`
    },
    params: ids && ids.length ? { id: ids } : undefined,
    paramsSerializer: (params) => {
      const search = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v) => search.append(key, String(v)));
        } else if (value !== undefined && value !== null) {
          search.append(key, String(value));
        }
      });
      return search.toString();
    },
    timeout: 60000
  })
}

export default getFleetExecutions
